import DepartmentAddPage from './add'
export default DepartmentAddPage
